import rebrand from '../../../config/rebrand';
import TokenRequest from '../tokenRequest';
import TokenStrategyFactory from '../../../auth/tokenStrategies/tokenStrategyFactory';
import { bootstrap, casEnabled } from '../../../auth/authService';

const PAGE_MANAGER_URL = rebrand.urls.PAGE_MANAGER_URL;

const casPath = 'v1/api/tokens';
const jwtPath = 'users/token/';
const tokenPath = casEnabled() ? casPath : jwtPath;

export default axiosInstance => async (error) => {
  const tokenRequest = new TokenRequest();

  if (!error.response) {
    return Promise.reject(error);
  }

  const { config, response } = error;

  if (response.status !== 401) {
    return Promise.reject(error);
  }

  if (config.tokenType === 'cas') {
    if (config.updateToken) {
      bootstrap.logout();
    }

    await bootstrap.signinSilent();

    config.updateToken = true;

    return axiosInstance(config);
  }

  if (response.status === 401) {
    if (config.url === tokenPath || config.updateToken) {
      window.location.href = PAGE_MANAGER_URL;
    } else {
      await tokenRequest.token();

      const token = TokenStrategyFactory.getTokenStrategy('jwt').getToken();

      config.updateToken = true;
      config.headers.Authorization = `Bearer ${token}`;

      return axiosInstance(config);
    }
  }
  return Promise.reject(error);
};



// WEBPACK FOOTER //
// ./src/services/request/interceptors/token.js